<template>
    <gofix-form-dropdown
        :vLabel="vLabel"
        :label="label" 
        :filterable="filterable" 
        :required="required"
        :show-icon-required="showIconRequired"
        :append-to-body="appendToBody"
        :disabled="disabled"
        :reduce="reduce"
        :options="options"
        @search="searchOptions"
        :value="value"
        @input="handleInput" >
        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
            <span>{{ option.contract_title || '--' }}</span>
        </template>
        <template slot="gofixInput:dropdown:option" slot-scope="option">
            <span v-b-tooltip.hover.topleft="{
                title: option.contract_title
            }">{{ option.contract_title || '--' }}</span>
        </template>
    </gofix-form-dropdown>
</template>

<script>
    export default {
        name: "dropdown-projects",
        props: {
            value: {
                required: true,
                default: () => null
            },
            vLabel: {
                type: String,
                required: false,
                default: () => "contract_title"
            },
            label: {
                type: String,
                required: false,
                default: () => "Project"
            },
            filterable: {
                type: Boolean,
                required: false,
                default: () => false
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },
            appendToBody: {
                type: Boolean,
                required: false,
                default: () => true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            reduce: {
                type: Function,
                default: option => option,
            },
        },

        data() {
            return {
                options: [],
                timer: null
            }
        },
        watch: {
            ClientContractID: function() {
                this.getOptions('', true)
            },
        },
        created(){
            this.getOptions('', true)
        },
        methods: {
            async getOptions(search = '', isDefault = false) {
                let tableRequest = {
                    filter: {
                        contract_title: search,
                        client_contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null,
                    },
                    limit: -1,
                    page: 1
                }
                await this.$store.dispatch("SafetyAppController/getProjects", tableRequest)
                    .then(response => {
                        this.options = response.items;
                        if(isDefault) {
                            this.$emit("setDefaultValue", this.options[0]);
                        }
                    })
                    .catch(err => {})
            },
            async searchOptions(search, loading) {
                loading(true)
                this.options = []
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getOptions(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            handleInput (e) {
                this.$emit("input", e);
                this.$emit("change", e);
            },
        }
    }
</script>

<style scoped>

</style>
